import { Label } from "components/Form/Label"
import { HelpMessage } from "components/Form/HelpMessage"
import { ErrorsList } from "components/ErrorsList"
import { InputDate } from "components/InputDate"
import { parseAbsoluteToLocal, parseDateTime } from "@internationalized/date"
import { sanitizeDateString } from "utils/date"

export const DateSingleTextField = ({
  label,
  value = "",
  id,
  name,
  onChange,
  description,
  errors,
  schema,
  min: minProps,
  max: maxProps,
}) => {
  const handleChange = (selectedDate) => {
    onChange?.(selectedDate ? selectedDate.toString() : null)
  }

  const minSchema = schema.options.attr?.min
    ? parseAbsoluteToLocal(schema.options.attr.min.padEnd(1, "Z"))
    : null
  const maxSchema = schema.options.attr?.max
    ? parseAbsoluteToLocal(schema.options.attr.max.padEnd(1, "Z"))
    : null

  const min = (minProps ?? minSchema)?.set({ hour: 12, minute: 0, second: 0 })
  const max = (maxProps ?? maxSchema)?.set({ hour: 12, minute: 0, second: 0 })

  return (
    <div className="space-y-1">
      {label ? (
        <div className="pl-4">
          <Label htmlFor={id}>{label}</Label>
        </div>
      ) : null}
      {description ? <HelpMessage>{description}</HelpMessage> : null}
      <div>
        <DatePicker
          value={value}
          name={name}
          onChange={handleChange}
          id={id}
          schema={schema}
          min={min}
          max={max}
          aria-label={label}
        />
      </div>
      {errors ? <ErrorsList errors={errors} /> : null}
    </div>
  )
}

const DatePicker = ({
  value,
  name,
  onChange,
  id,
  min,
  max,
  schema,
  ...props
}) => {
  const valueDate = value ? parseDateTime(sanitizeDateString(value)) : null

  return (
    <InputDate
      value={valueDate}
      name={name}
      onChange={onChange}
      id={id}
      minDate={min}
      maxDate={max}
      variant={getVariant(schema.options.widget)}
      {...props}
    />
  )
}

const getVariant = (widget) => {
  switch (widget) {
    case "date_single_text":
      return "date"

    case "date_time_single_text":
      return "datetime"

    default:
      return "date"
  }
}
